import { EntityBase } from "./EntityBase";
import { Company } from "./Company";
import { Utility } from "./Utility";
import { State } from "./State";

export class User extends EntityBase {
    isActive: boolean = false;
    firstName: string = null!;
    lastName: string = null!;
    isSupplier: boolean | null = null;
    isAdvisor: boolean | null = null;
    jobTitle: string = null!;
    email: string = null!;
    phone: string = null!;
    totalLogins: number = 0;
    lastLogin: Date = null!;
    company: Company | null = null;
    autoTransactionsOn: boolean = true;
    state: State | null = null;
    city: string | null = null;
    addressLine1: string | null = null;
    addressLine2: string | null = null;
    zip: string | null = null;
    kilowantUViewed: boolean | null = null;
    firstAccountSetupFinished: boolean | null = null;
    utilities: Utility[] = null!;
    isPreRegister: boolean = true;
    nameAsClient: string | null = null;

    getEmail(): string {
        return this.email;
    }
}
